import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import { apiUrls } from '../../../config/api/api-urls.config';
import { SlotRewardsResultsResponse } from '../../../models/slots/responses/api-slot-rewards-results-response.model';
import { SlotTestResponse } from '../../../models/slots/responses/api-slot-test-response.model';
import { SlotCreditBalanceResultsResponse } from '../../../models/slots/responses/api-slot-credit-balance-response.model';

@Injectable({
  providedIn: 'root'
})
export class ApiSlotsService {

  constructor(private apiService: ApiService) { }

  getSlotRewards(): Promise<SlotRewardsResultsResponse> {
    return new Promise<SlotRewardsResultsResponse>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(apiUrls.slotGetSlotRewardsUrl, {}, SlotRewardsResultsResponse).then(
        (data: SlotRewardsResultsResponse) => { resolve(data); }, error => { reject(error); });
    });
  }

  addSlotReward(rewardRank: number, multiplier: number, rarityWeight: number, isJackpot: boolean): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(apiUrls.slotAddSlotRewardUrl, { reward_rank: rewardRank, multiplier: multiplier, rarity_weight: rarityWeight, is_jackpot: isJackpot }).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  editSlotReward(rewardRank: number, multiplier: number, rarityWeight: number, isJackpot: boolean): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(apiUrls.slotEditSlotRewardUrl, { reward_rank: rewardRank, multiplier: multiplier, rarity_weight: rarityWeight, is_jackpot: isJackpot }).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  deleteSlotReward(rewardRank: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(apiUrls.slotDeleteSlotRewardUrl, { reward_rank: rewardRank }).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  testSlot(launchCount: number): Promise<SlotTestResponse> {
    return new Promise<SlotTestResponse>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(apiUrls.slotTestSlotUrl, { launch_count: launchCount }, SlotTestResponse).then(
        (data: SlotTestResponse) => { resolve(data); }, error => { reject(error); });
    });
  }

  getSlotCreditBalance(): Promise<SlotCreditBalanceResultsResponse> {
    return new Promise<SlotCreditBalanceResultsResponse>((resolve, reject) => {
      this.apiService.launchAdminApiRequestGet(apiUrls.slotGetSlotCreditBalanceUrl, SlotCreditBalanceResultsResponse).then(
        (data: SlotCreditBalanceResultsResponse) => { resolve(data); }, error => { reject(error); });
    });
  }
}
